import React,{useState} from 'react'
import '../Materi/Materi.css'
import Sidebar from './Sidebar/Sidebar'
import {BrowserRouter, Switch, Route, useLocation } from "react-router-dom";
import Pertidaksamaan from './Pages/Pertidaksamaan/Pertidaksamaan'
// import KuisPert from './Pages/Pertidaksamaan/Kuis/Kuis'
import Programlinear from './Pages/Programlinear/Programlinear'
import Kuis from './Pages/Programlinear/Kuis/Kuis'
import NotFound from '../../views/Errors/NotFound';
import NilaiOptimum from './Pages/NilaiOptimum/NilaiOptimum'
import Evaluasi from './Pages/Evaluasi/Evaluasi'
import styled from "styled-components";

const Pages = styled.div`

    // width: 100vw;
    width: ${props => props.click ? "85vw" : "100vw"};
    height: 100vh;
     display: flex;
    justify-content: center;
    padding: 1rem 0 2rem 0;
     background: white;
    h1 {
        font-size: calc(1rem + 1vw);
        background: linear-gradient(to right, #0b6d3c 30%, #1b1b1b 100%);
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
    }
    margin-top: 0.5rem;
    // z-index:50;
`;
const Materi = () => {
    const [click, setClick] = useState(false);    
    const handleClick = () => setClick(!click);
    const location = useLocation();
    return (
        <div style={{display:'flex'}}>
            <Sidebar click={click} handleClick={handleClick}/>

                <Pages>
                    
                    <BrowserRouter>
                    <Switch location={location} key={location.pathname}>
                   
                        <Route exact path="/materi">                            
                            <Pertidaksamaan  click={click}/>
                        </Route>
                     
                        <Route path="/materi/programlinear">
                            <Programlinear  click={click}/>
                        </Route>
                        <Route path="/materi/nilai">
                            <NilaiOptimum  click={click}/>
                        </Route>
                        <Route path="/materi/evaluasi">
                            <Evaluasi  click={click}/>
                        </Route>
                        <Route path="/materi/kuis2">
                            <Kuis  click={click}/>
                        </Route>
                         <Route path="/materi/*">
                            <NotFound click={click}/>
                        </Route>                        
                    </Switch>
                    </BrowserRouter>                  
                   
                </Pages>   
               
        </div>
        
    )
}

export default Materi
            